import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { epcPayload, statLabel } from "@/lib/stationery";

// Betaal-QR (SEPA/EPC): de bankapp vult begunstigde, IBAN, bedrag en mededeling zelf in.
export default function PayQR({ camp = {}, lang = "nl", amount = 0, reference = "", size = 92 }) {
  const payload = epcPayload(camp, amount, reference);
  if (!payload) return null;
  return (
    <div className="flex items-center gap-3 break-inside-avoid" data-testid="pay-qr">
      <QRCodeSVG value={payload} size={size} level="M" />
      <div className="text-[9px] leading-snug text-slate-600">
        <p className="font-semibold text-slate-800">{statLabel(lang, "scan")}</p>
        <p>{camp.camp_name}</p>
        <p>IBAN {camp.bank_account}</p>
        {reference && <p>{reference}</p>}
      </div>
    </div>
  );
}
